export function Footer() {
  return (
    <footer className="bg-gradient-to-br from-gray-900 to-gray-800 text-white py-16">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid md:grid-cols-3 gap-12 mb-12">
          {/* Brand */}
          <div>
            <img 
              src="https://freewebsiteoffer.99-marketing.com/wp-content/uploads/2026/02/logo.png" 
              alt="Digital Age Marketing" 
              className="h-12 mb-6"
            />
            <p className="text-gray-400 leading-relaxed">
              Modern websites combined with powerful SEO visibility systems designed to help businesses grow online.
            </p>
          </div>

          {/* Contact */}
          <div>
            <h3 className="text-xl font-bold mb-4">Contact Us</h3>
            <div className="space-y-3">
              <a 
                href="tel:8004559670"
                className="flex items-center gap-3 text-gray-400 hover:text-teal-400 transition-colors cursor-pointer"
              >
                <i className="ri-phone-line text-xl"></i>
                <span>800-455-9670</span>
              </a>
              <a 
                href="mailto:info@digitalagemarketing.com"
                className="flex items-center gap-3 text-gray-400 hover:text-teal-400 transition-colors cursor-pointer"
              >
                <i className="ri-mail-line text-xl"></i>
                <span>info@digitalagemarketing.com</span>
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-xl font-bold mb-4">Quick Links</h3>
            <div className="space-y-3">
              <button 
                onClick={() => document.getElementById('contact-form')?.scrollIntoView({ behavior: 'smooth' })}
                className="block text-gray-400 hover:text-teal-400 transition-colors cursor-pointer text-left"
              >
                Request Website + SEO Plan
              </button>
              <a 
                href="tel:8004559670"
                className="block text-gray-400 hover:text-teal-400 transition-colors cursor-pointer"
              >
                Schedule a Call
              </a>
            </div>
          </div>
        </div>

        <div className="border-t border-gray-700 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-gray-400 text-sm">
              © 2026 Digital Age Marketing. All rights reserved.
            </p>
            <div className="flex items-center gap-6">
              <a href="#" className="text-gray-400 hover:text-teal-400 transition-colors text-sm cursor-pointer">
                Privacy Policy
              </a>
              <a href="#" className="text-gray-400 hover:text-teal-400 transition-colors text-sm cursor-pointer">
                Terms of Service
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}